"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoverageKPIUserAttributes = exports.DefaultCoverageKPIs = exports.AreaSubTypeEnum = exports.AreaSubType = void 0;
const tslib_1 = require("tslib");
const config_1 = tslib_1.__importDefault(require("@iotv/config"));
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const defaultAreaSubTypes = ['Coverage'];
exports.AreaSubType = [...defaultAreaSubTypes, ...(config_1.default.ventureTypeExtensions?.Area?.subtype || [])];
exports.AreaSubTypeEnum = (0, iotv_v3_types_1.getEnumShape)(exports.AreaSubType);
exports.DefaultCoverageKPIs = {
    DLPerDay: 1000,
    ULPerDay: 5000,
    droppedULPercentKpiGood: 5,
    droppedULPercentKpiOk: 10,
    droppedULPercentKpiPoor: 20,
    espKpi: -135,
    espGood: 95,
    espOk: 75,
    espPoor: 50,
};
exports.CoverageKPIUserAttributes = {
    espKpi: { type: 'Number', hideFromList: true, editable: true, label: 'ESP KPI', default: -135 },
    espGood: { type: 'Number', hideFromList: true, editable: true, label: 'ESP Good', default: 95, valueFormatter: (v) => `${v}%` },
    espOk: { type: 'Number', hideFromList: true, editable: true, label: 'ESP OK', default: 75, valueFormatter: (v) => `${v}%` },
    espPoor: { type: 'Number', hideFromList: true, editable: true, label: 'ESP Poor', default: 50, valueFormatter: (v) => `${v}%` },
    DLPerDay: { type: 'Number', hideFromList: true, editable: true, label: 'Downlinks Per Day', default: 1000 },
    ULPerDay: { type: 'Number', hideFromList: true, editable: true, label: 'Uplinks Per Day', default: 5000 },
    droppedULPercentKpiGood: { type: 'Number', hideFromList: true, editable: true, label: 'Uplink KPI Good', default: 5, valueFormatter: (v) => `${v}%` },
    droppedULPercentKpiOk: { type: 'Number', hideFromList: true, editable: true, label: 'Uplink KPI OK', default: 10, valueFormatter: (v) => `${v}%` },
    droppedULPercentKpiPoor: { type: 'Number', hideFromList: true, editable: true, label: 'Uplink KPI Poor', default: 20, valueFormatter: (v) => `${v}%` },
};
